export const API_URL = "https://api.unifiedpatents.com";
export const PATTY_API_URL = "https://patty.unifiedpatents.com";
export const PATROLL_API_URL = "https://patroll.unifiedpatents.com";
export const GOOGLE_DRIVE_URL = "https://www.googleapis.com/drive/v2/files";
export const GOOGLE_SHEET_URL = "https://sheets.googleapis.com/v4/spreadsheets";
export const AUTH0_CLIENT_ID = "rTvNlpJlWbTJQKD2ABbAOcxuVl6EH4iI";
export const AUTH0_DOMAIN = "accounts.unifiedpatents.com";
export const PUBLIC_ASSETS_URL = "https://public-assets.unifiedpatents.com";
export const PUBLIC_URL = "https://portal.unifiedpatents.com";
export const PEARL_BUCKET_NAME = "pearl-upload"